import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-business-rc-company-insurance-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_522_2328)">
        <path
          d="M15.75 8.25V1.5C15.7496 1.37905 15.72 1.25998 15.6636 1.15295C15.6073 1.04593 15.5259 0.954119 15.4264 0.885357C15.3269 0.816595 15.2122 0.772921 15.0922 0.758058C14.9721 0.743195 14.8503 0.757585 14.737 0.8L6.487 5.07C6.34434 5.12342 6.22133 5.21901 6.13434 5.34405C6.04734 5.4691 6.00048 5.61767 6 5.77V9.75"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.5 5.25H15.75"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 8.25H15.75"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.75 12.75H3"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.75 15.75H4.5"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.25 4.156V0.751"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.25 23.25V11.25C8.25 10.8522 8.09196 10.4706 7.81066 10.1893C7.52936 9.90804 7.14782 9.75 6.75 9.75H2.25C1.85218 9.75 1.47064 9.90804 1.18934 10.1893C0.908035 10.4706 0.75 10.8522 0.75 11.25V23.25H9.75"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M23.25 15.75C23.2534 17.4965 22.6605 19.1918 21.5695 20.5556C20.4785 21.9194 18.9546 22.8699 17.25 23.25C15.5454 22.8699 14.0215 21.9194 12.9305 20.5556C11.8395 19.1918 11.2466 17.4965 11.25 15.75V12.75C11.25 12.3522 11.408 11.9706 11.6893 11.6893C11.9706 11.408 12.3522 11.25 12.75 11.25H21.75C22.1478 11.25 22.5294 11.408 22.8107 11.6893C23.092 11.9706 23.25 12.3522 23.25 12.75V15.75Z"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.25 15V19.5"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15 17.25H19.5"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_522_2328">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
})
export class BusinessRcCompanyInsuranceIconComponent extends BaseIconComponent {}
